module.exports = __webpack_public_path__ + "static/media/tensile.49d34eac.png";